import styled from "styled-components"

export const EditorWrapper = styled.div`
  // Hide TinyMCE branding
  .tox-statusbar__branding {
    display: none;
  }
`
